import r from "@brazilian-utils/helper-only-numbers";
import n from "@brazilian-utils/helper-generate-checksum";

var e = ["00000000000000", "11111111111111", "22222222222222", "33333333333333", "44444444444444", "55555555555555", "66666666666666", "77777777777777", "88888888888888", "99999999999999"],
    t = [12, 13],
    i = function i(r) {
  return 14 === r.length;
},
    u = function u(r) {
  return e.includes(r);
},
    l = function l(r) {
  return t.every(function (e) {
    var i = r.slice(0, e).split(""),
        u = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    e === t[t.length - 1] && u.unshift(6);
    var l = n(i, u) % 11;
    return r[e] === String(l < 2 ? 0 : 11 - l);
  });
};

export default function (n) {
  if (!n) return !1;
  var e = r(n);
  return i(e) && !u(e) && l(e);
}
;